/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_SettingsInputs */

const en_translation_settings = /** @type {(inputs: Translation_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation Settings`)
};

const fr_translation_settings = /** @type {(inputs: Translation_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de traduction`)
};

const de_translation_settings = /** @type {(inputs: Translation_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzungseinstellungen`)
};

const it_translation_settings = /** @type {(inputs: Translation_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni di traduzione`)
};

const ru_translation_settings = /** @type {(inputs: Translation_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки перевода`)
};

const es_translation_settings = /** @type {(inputs: Translation_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración de traducción`)
};

const zh_cn2_translation_settings = /** @type {(inputs: Translation_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译设置`)
};

const ja_translation_settings = /** @type {(inputs: Translation_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳設定`)
};

const hi_translation_settings = /** @type {(inputs: Translation_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद सेटिंग्स`)
};

const pt_pt2_translation_settings = /** @type {(inputs: Translation_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações de tradução`)
};

/**
* | output |
* | --- |
* | "Translation Settings" |
*
* @param {Translation_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_settings = /** @type {((inputs?: Translation_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_settings(inputs)
	if (locale === "de") return de_translation_settings(inputs)
	if (locale === "it") return it_translation_settings(inputs)
	if (locale === "ru") return ru_translation_settings(inputs)
	if (locale === "es") return es_translation_settings(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_settings(inputs)
	if (locale === "ja") return ja_translation_settings(inputs)
	if (locale === "hi") return hi_translation_settings(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_settings(inputs)
	return en_translation_settings(inputs)
});